/**
 * TanStack Query provider component
 */


import { type QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { ApiClient } from '../client/api-client'
import { createQueryClient } from './query-client'
import { setGlobalApiClient } from './hooks'
import type { ReactNode } from 'react'

/**
 * Query provider props
 */
export interface QueryProviderProps {
  children: ReactNode,
  apiClient?: ApiClient
  queryClient?: QueryClient
}

/**
 * Query provider component that sets up TanStack Query
 */
export function QueryProvider({ children, apiClient, queryClient }: QueryProviderProps) {
  // Create query client if not provided
  const client = queryClient || createQueryClient(apiClient)

  // Set global API client for hooks
  if (apiClient) {
    setGlobalApiClient(apiClient)
  }

  return (
    <QueryClientProvider client={client}>
      {children as React.JSX.Element}
      {/* DevTools would be added here in development */}
    </QueryClientProvider>
  )
}

/**
 * Hook to access the query client
 */
export { useQueryClient } from '@tanstack/react-query'
